import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  return <section className="w-full bg-dark py-24 border-b border-dark-lighter" data-id="element-227">
      <div className="max-w-5xl mx-auto px-6" data-id="element-228">
        <FadeIn data-id="element-229">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-230">
            {/* WHO IT IS FOR */}
            <div className="bg-dark-panel border border-cyan-accent/30 p-8 md:p-10" data-id="element-231">
              <h2 className="font-display text-3xl uppercase mb-8 text-white flex items-center gap-3" data-id="element-232">
                <span className="bg-cyan-accent/20 p-2 rounded-sm" data-id="element-233">
                  <Check className="w-6 h-6 text-cyan-accent" data-id="element-234" />
                </span>
                Who This Is For
              </h2>
              <ul className="space-y-6" data-id="element-235">
                <li className="flex items-start gap-4" data-id="element-236">
                  <Check className="w-6 h-6 text-cyan-accent shrink-0 mt-1" data-id="element-237" />
                  <span className="text-gray-300" data-id="element-238">
                    Remote executives and office-bound professionals age 40+.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-239">
                  <Check className="w-6 h-6 text-cyan-accent shrink-0 mt-1" data-id="element-240" />
                  <span className="text-gray-300" data-id="element-241">
                    People who feel "stiff as a board" every time they get out
                    of a car or chair.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-242">
                  <Check className="w-6 h-6 text-cyan-accent shrink-0 mt-1" data-id="element-243" />
                  <span className="text-gray-300" data-id="element-244">
                    Anyone experiencing shooting pains, numbness, or "pins and
                    needles" in their legs.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-245">
                  <Check className="w-6 h-6 text-cyan-accent shrink-0 mt-1" data-id="element-246" />
                  <span className="text-gray-300" data-id="element-247">
                    High-performers who have zero time for the gym but refuse to
                    live in pain.
                  </span>
                </li>
              </ul>
            </div>

            {/* WHO IT IS NOT FOR */}
            <div className="bg-dark-panel border border-red-500/30 p-8 md:p-10" data-id="element-248">
              <h2 className="font-display text-3xl uppercase mb-8 text-white flex items-center gap-3" data-id="element-249">
                <span className="bg-red-500/20 p-2 rounded-sm" data-id="element-250">
                  <X className="w-6 h-6 text-red-500" data-id="element-251" />
                </span>
                Who This Is Not For
              </h2>
              <ul className="space-y-6" data-id="element-252">
                <li className="flex items-start gap-4" data-id="element-253">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-254" />
                  <span className="text-gray-300" data-id="element-255">
                    People looking for a bodybuilding or weight-loss program.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-256">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-257" />
                  <span className="text-gray-300" data-id="element-258">
                    Pro athletes who already have 2 hours a day for mobility
                    work.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-259">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-260" />
                  <span className="text-gray-300" data-id="element-261">
                    Those unwilling to dedicate 8 minutes of their work day to
                    their health.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}